/**
 * An attendee's single reusable saved signature for the HSE training sign-in
 * sheet, carried to and from the Sparta API as a base64-encoded PNG with NO
 * data-URI prefix. Keyed server-side by the scanned employee's HRRef (the key
 * travels in the route, not the body). Offered for confirm-and-reuse on later
 * sign-ins so a repeat attendee does not re-draw their signature.
 *
 * Contract note: the API stores and returns BARE base64. Every client drawing
 * surface (the DynamicRender signature control on mobile) speaks data-URI
 * strings (`data:image/png;base64,...`). Reuse the bare-base64 <-> data-URI
 * helpers in `foreman-user-signature.model.ts` (`toBareSignatureBase64` /
 * `toSignatureDataUrl`) at the boundary, never inline the prefix handling.
 *
 * Distinct from `ForemanUserSignatureDto`: that one is keyed by the logged-in
 * user signing their OWN timesheet; this one is keyed by an arbitrary scanned
 * attendee (HRRef), so the two stores stay separate (WI 31501).
 */
export interface EmployeeSignatureDto {
  /** Bare base64-encoded PNG bytes, no `data:` prefix. */
  signatureBase64: string;
  /** MIME type of the stored image, e.g. `image/png`. */
  contentType: string;
  modifiedDate?: Date | string | null;
}
